import { render, staticRenderFns } from "./ExemptRentChange.vue?vue&type=template&id=9bb06d4c&scoped=true&"
import script from "./ExemptRentChange.vue?vue&type=script&lang=js&"
export * from "./ExemptRentChange.vue?vue&type=script&lang=js&"
import style0 from "./ExemptRentChange.vue?vue&type=style&index=0&id=9bb06d4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb06d4c",
  null
  
)

export default component.exports